// extracted by mini-css-extract-plugin
export default {"lds-ring":"LoadingBtn_lds-ring__D7e1X"};